import { render, staticRenderFns } from "./relatorioCadUsuarioRetrato.vue?vue&type=template&id=1b376260"
import script from "./relatorioCadUsuarioRetrato.vue?vue&type=script&lang=js"
export * from "./relatorioCadUsuarioRetrato.vue?vue&type=script&lang=js"
import style0 from "./relatorioCadUsuarioRetrato.vue?vue&type=style&index=0&id=1b376260&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports